export default [
  {
    path: '/relatorio-comissoes',
    name: 'relatorio-comissoes',
    component: () => import('@/views/relatorios/comissoes/Index.vue'),
    meta: {
      actions: 'manage',
      resource: 'all',
    },
  },
];
